import { HomeOutlined } from '@ant-design/icons'
import { Breadcrumb } from 'antd'

import { PTOV2Provider } from 'context/pto-v2-context-provider'

import Content from './content'
import Overview from './overview'

import './style.scss'

const PTOV2Detail = () => {
  return (
    <PTOV2Provider>
      <div className="main-section p2p-detail">
        <Breadcrumb
          items={[
            {
              href: '/',
              title: <HomeOutlined />,
            },
            {
              title: <span>PTO v2 Detail</span>,
            },
          ]}
          style={{ marginBottom: '20px' }}
        />
        <Overview />
        <Content />
      </div>
    </PTOV2Provider>
  )
}

export default PTOV2Detail
